<template>
    <vs-table class="freeze_row row2" :data="results" slot="no-body" :hoverFlat="true" stripe>
        <vs-tr>
            <vs-th>ID</vs-th>
            <vs-th style="min-width: 120px;">Issue Date</vs-th>
            <vs-th style="min-width: 120px;">Date Created</vs-th>
            <vs-th style="min-width: 120px;">Closed Status</vs-th>
            <vs-th style="min-width: 120px;">Closed On</vs-th>
            <vs-th style="min-width: 120px;">Reporter Name</vs-th>
            <vs-th style="min-width: 120px;">Type</vs-th>
            <vs-th style="min-width: 120px;">Category</vs-th>
            <vs-th style="min-width: 90px;">Issue Type</vs-th>
            <vs-th style="min-width: 150px;">Incident Manager</vs-th>
            <vs-th style="min-width: 150px;" v-if="report_mode">Close out assigned to</vs-th>
            <vs-th style="min-width: 150px;" v-if="report_mode">Target close out date</vs-th>
            <vs-th style="min-width: 75px;" v-if="report_mode">Potential</vs-th>
            <vs-th style="min-width: 120px;" v-if="!report_mode">View Issue</vs-th>
            <vs-th style="min-width: 120px;">Approval Status</vs-th>
            <vs-th style="min-width: 120px;" v-if="!report_mode">View Resolution</vs-th>
            <vs-th style="min-width: 150px;">Resolution Status (PO)</vs-th>
            <vs-th style="min-width: 130px;">Resolution Status</vs-th>
            <vs-th style="min-width: 130px;" v-if="!report_mode">Change Assignee</vs-th>
            <vs-th style="min-width: 120px;" v-if="!report_mode">Delete Action</vs-th>
        </vs-tr>
        <template>
            <template v-for="(item, index) in results">
                <vs-tr :key="index">
                    <vs-td>
                        <template v-if="item.sync_mode == 'offline'">
                            <div class="flex" style="justify-content: center; align-items: center;">
                                {{ item.data.id }}&ensp;
                                <vx-tooltip text= "Offline Issue" color="primary">
                                    <font-awesome-icon class="text-primary" :icon="offlineIcon"/>
                                </vx-tooltip> 
                            </div>
                        </template>
                        <template v-else>
                            {{ item.data.id }}
                        </template>
                    </vs-td>
                    <vs-td>
                        <FormatText :text="item.data.date" format="date" />
                    </vs-td>
                    <vs-td>
                        <FormatText :text="item.created_on" format="datetime" />
                    </vs-td>
                    <vs-td>
                        <div :class="{'text-warning': item.closed_status =='p', 'text-danger': item.closed_status =='r', 'text-success': item.closed_status =='c', 'font-bold': true}">
                            <FormatText :text="item.closed_status" format="select" :kwargs="[{label: 'Pending', value: 'p'},{label: 'Rejected', value: 'r'},{label: 'Completed', value: 'c'}]"  />
                        </div>
                    </vs-td>
                    <vs-td>
                        <template v-if="item.closed_on">
                            <FormatText :text="item.closed_on" format="datetime" />
                        </template>
                        <template v-else>
                            -
                        </template>
                    </vs-td>
                    <vs-td>
                        {{ item.reported_by.first_name }} {{ item.reported_by.last_name }}
                    </vs-td>
                    <vs-td>
                        {{ item.data.hazard_type.name }}
                    </vs-td>
                    <vs-td>
                        {{ item.data.category.name }}
                    </vs-td>
                    <vs-td>
                        {{ item.data.issue_type ? item.data.issue_type.name : '-' }}
                    </vs-td>
                    <vs-td>
                        {{ item.assigned_reviewers.map(v => `${v.first_name} ${v.last_name}`).join(',') }}
                    </vs-td>
                    <vs-td v-if="report_mode">
                        {{ item.data.close_out_assigned_to }}
                    </vs-td>
                    <vs-td v-if="report_mode">
                        {{ item.data.target_close_out_date }}
                    </vs-td>
                    <vs-td v-if="report_mode">
                        <FormatText :text="item.data.potential" format="select" :kwargs="[{label: 'High', value: 'h'}, {label: 'Medium', value: 'm'}, {label: 'Low', value: 'l'}]" />
                    </vs-td>              
                    <vs-td v-if="!report_mode">
                        <template v-if="item.status == 'r' && editIssue(item)">
                            <router-link :to="{name: 'issues-edit', params: {issue_type: item.issue_type, issue_id: item.id}}">
                                <vs-button type="filled" size="small" color="primary">Edit</vs-button>
                            </router-link>
                        </template>
                        <router-link :to="{name: 'issues-view', params: {issue_type: item.issue_type, issue_id: item.id}}" v-else>
                            <vs-button type="filled" size="small" color="primary">View</vs-button>
                        </router-link>
                    </vs-td>
                    <vs-td>
                        <div v-if="item.status == 'p'" class="text-warning font-bold">
                            Pending
                        </div>
                        <div v-else-if="item.status == 'r'" class="text-danger font-bold">
                            Rejected
                        </div>
                        <div v-else-if="item.status == 'a'" class="text-success font-bold">
                            Approved
                        </div>
                    </vs-td>
                    <vs-td v-if="!report_mode">
                        <router-link :to="{name: 'issues-resolution', params: {issue_type: item.issue_type, issue_id: item.id}}">
                            <vs-button type="filled" size="small" color="primary">View</vs-button>
                        </router-link>
                    </vs-td>
                    <vs-td>
                        <div v-if="item.resolution_status_se == null" class="text-warning font-bold">
                            Not Started/Applicable
                        </div>
                        <div v-else-if="item.resolution_status_se == 'p'" class="text-warning font-bold">
                            Pending
                        </div>
                        <div v-else-if="item.resolution_status_se == 'r'" class="text-danger font-bold">
                            Rejected
                        </div>
                        <div v-else-if="item.resolution_status_se == 'a'" class="text-success font-bold">
                            Approved
                        </div>
                    </vs-td>
                    <vs-td>
                        <div v-if="item.resolution_status == null" class="text-warning font-bold">
                            Not Started
                        </div>
                        <div v-else-if="item.resolution_status == 'p'" class="text-warning font-bold">
                            Pending
                        </div>
                        <div v-else-if="item.resolution_status == 'r'" class="text-danger font-bold">
                            Rejected
                        </div>
                        <div v-else-if="item.resolution_status == 'a'" class="text-success font-bold">
                            Approved
                        </div>
                    </vs-td>
                    <vs-td v-if="!report_mode">
                        <template v-if="item.status == 'p' && changeIssueAssignee(item)">
                            <vs-button @click="set_popup_data(index)" color="primary" type="filled" size="small">Change</vs-button>
                            <vs-popup title="Change Assignee" :active.sync="popupActive">
                                <div class="mb-3">
                                    <h6>Issue ID: #{{ popup_data.secondary_issue_id }}</h6>
                                    <span>Current Assignee: {{ popup_data.previous_assignee ? popup_data.previous_assignee.map(v => `${v.first_name} ${v.last_name}`).join(', ') : '' }}</span>
                                </div>
                                <SelectForeign
                                    :model.sync="popup_data.assigned_reviewers"
                                    label="Incident Manager"
                                    placeholder="Type to Search..."
                                    :multiple="true"
                                    :load_initial="true"
                                    :label_keys="['first_name', 'last_name']"
                                    :show_id_in_label="false"
                                    :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${manager_dropdown()}&is_active=true`"
                                    container_class="w-full"
                                    input_class=""
                                    :use_id_as_value="false"
                                    :close_on_select="false"
                                    :disabled="submit_disabled"
                                    :use_cache="true"
                                />
                                <small class="block text-danger mt-1" v-if="api_errors && api_errors.assigned_reviewers">
                                    {{ api_errors.assigned_reviewers.join(', ') }}
                                </small>
                                <vs-button @click="change_assignee()" class="mt-base" color="primary" type="filled" size="small" :disabled="submit_disabled">Save</vs-button>
                            </vs-popup>
                        </template>
                        <template v-else>
                            Can't Change Assignee
                        </template>
                    </vs-td>
                    <vs-td v-if="!report_mode">
                        <template v-if="delete_permission(item)">
                            <vx-tooltip text= "Delete" color="danger">
                                <vs-button @click="$emit('do_delete', item.id)" size="small" type="flat">
                                    <font-awesome-icon size="2x" class="text-danger" :icon="deleteIcon"/>
                                </vs-button>
                            </vx-tooltip>
                        </template>
                        <template v-else>
                            -
                        </template>
                    </vs-td>
                </vs-tr>
            </template>
        </template>
    </vs-table>
</template>

<script>
import { faCheckCircle, faTimesCircle, faBolt, faTrash } from '@fortawesome/free-solid-svg-icons'
import { Request } from '../../../utils/requests'
export default {
    props: {
        results: {
            type: Array,
            required: true
        },
        report_mode: {
            type: Boolean,
            required: false
        },
        delete_permission: {
            type: Function,
            require: true
        },
        changeIssueAssignee: {
            type: Function,
            require: true
        },
        manager_dropdown: {
            required: true,
            type: Function
        },
        editIssue: {
            required: true,
            type: Function
        }
    },
    data() {
        return {
            popupActive: false,
            popup_data: {
                issue_id: null,
                previous_assignee: null,
                assigned_reviewers: [],
            },
            api_errors: null,
            submit_disabled: false,
        }
    },
    computed: {
        approveIcon: () => faCheckCircle,
        rejectIcon: () => faTimesCircle,
        offlineIcon: () => faBolt,
        deleteIcon: () => faTrash
    },
    methods: {
        set_popup_data(index) {
            this.popup_data.issue_id = this.results[index].id
            this.popup_data.secondary_issue_id = this.results[index].data.id
            this.popup_data.previous_assignee = this.results[index].assigned_reviewers
            this.popupActive = true
        },
        change_assignee() {

            if(this.popup_data.assigned_reviewers.length == 0) {
                this.api_errors = {
                    "assigned_reviewers": [
                        "Please select atleast 1 Incident Manager.",
                    ]
                }

                return
            }

            let payload = {
                action: 'change_assignee',
                assigned_reviewers: this.popup_data.assigned_reviewers.map(v => v.id)
            }

            this.submit_disabled = true
            this.$vs.loading()

            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.data_issue_action, this.popup_data.issue_id), null, payload).then(
                (res) => {
                    this.submit_disabled = false
                    this.$vs.loading.close()
                    this.popupActive = false
                    this.popup_data.assigned_reviewers = []

                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: "Action completed successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })

                    this.$router.push({name: 'issues-list', params: {issue_type: 'hazard'}})
                },
                err => {
                    this.submit_disabled = false
                    this.$vs.loading.close()
                    this.popupActive = false
                    this.popup_data.assigned_reviewers = []

                    if (err.error) {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An server error occurred while processing your request.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
    }
}
</script>